import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from 'client/slices/authSlice';
import allRoutes from 'client/constants/allRoutes';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedClinicName } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleExit = () => {
    const savedToken = sessionStorage.getItem('superadmin_token');
    const savedAuth = sessionStorage.getItem('superadmin_auth');

    if (savedToken && savedAuth) {
      const parsed = JSON.parse(savedAuth);
      localStorage.setItem('token', savedToken);
      dispatch(login(parsed));
      sessionStorage.removeItem('superadmin_token');
      sessionStorage.removeItem('superadmin_auth');
      navigate(allRoutes.superadminClinics);
    }
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-3 z-50 shrink-0">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" fill="currentColor"/>
      </svg>
      <span>Impersonating: <strong>{impersonatedClinicName}</strong></span>
      <button
        onClick={handleExit}
        className="bg-white text-amber-600 px-3 py-1 rounded text-xs font-bold hover:bg-amber-50 transition-colors"
      >
        Exit to Super Admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
